/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@shared/apis/fetch-clients/crm-fetch-client";
import type { GetContactWithPendingChangesetQueryResponse, GetContactWithPendingChangesetPathParams, GetContactWithPendingChangesetHeaderParams, GetContactWithPendingChangeset401 } from "../../models/contactsController/GetContactWithPendingChangeset";
import type { Client, RequestConfig, ResponseErrorConfig } from "@shared/apis/fetch-clients/crm-fetch-client";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getContactWithPendingChangesetQueryKey = (contactId: GetContactWithPendingChangesetPathParams["contactId"]) => [{ url: '/contacts/:contactId/pending-changeset', params: {contactId:contactId} }] as const

export type GetContactWithPendingChangesetQueryKey = ReturnType<typeof getContactWithPendingChangesetQueryKey>

/**
 * {@link /contacts/:contactId/pending-changeset}
 */
export async function getContactWithPendingChangeset(contactId: GetContactWithPendingChangesetPathParams["contactId"], headers?: GetContactWithPendingChangesetHeaderParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetContactWithPendingChangesetQueryResponse, ResponseErrorConfig<GetContactWithPendingChangeset401>, unknown>({ method : "GET", url : `/contacts/${contactId}/pending-changeset`, ... requestConfig, headers : { ...headers, ...requestConfig.headers } })
  return res.data
}

export function getContactWithPendingChangesetQueryOptions(contactId: GetContactWithPendingChangesetPathParams["contactId"], headers?: GetContactWithPendingChangesetHeaderParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getContactWithPendingChangesetQueryKey(contactId)
        return queryOptions<GetContactWithPendingChangesetQueryResponse, ResponseErrorConfig<GetContactWithPendingChangeset401>, GetContactWithPendingChangesetQueryResponse, typeof queryKey>({
         enabled: !!(contactId),
         queryKey,
         queryFn: async ({ signal }) => {
            return getContactWithPendingChangeset(contactId, headers, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * {@link /contacts/:contactId/pending-changeset}
 */
export function useGetContactWithPendingChangeset<TData = GetContactWithPendingChangesetQueryResponse, TQueryData = GetContactWithPendingChangesetQueryResponse, TQueryKey extends QueryKey = GetContactWithPendingChangesetQueryKey>(contactId: GetContactWithPendingChangesetPathParams["contactId"], headers?: GetContactWithPendingChangesetHeaderParams, options: 
{
  query?: Partial<QueryObserverOptions<GetContactWithPendingChangesetQueryResponse, ResponseErrorConfig<GetContactWithPendingChangeset401>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getContactWithPendingChangesetQueryKey(contactId)
         

         const query = useQuery({
          ...getContactWithPendingChangesetQueryOptions(contactId, headers, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetContactWithPendingChangeset401>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}